var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignCanvas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 135 112",
    width: 135,
    height: 112,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "design_canvas-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m49.87 84.2l56.29 52.22 67.96-37.51-86.22-68.76z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #00aec7 } \n\t\t.s1 { fill: #048598 } \n\t\t.s2 { fill: none;stroke: #ffffff;stroke-width: 2 } \n\t\t.s3 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13171",
    className: "s0",
    d: "m0 10c0-5.5 4.5-10 10-10h115c5.5 0 10 4.5 10 10v92c0 5.5-4.5 10-10 10h-115c-5.5 0-10-4.5-10-10z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path: Mask_Group_5",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13172",
    className: "s1",
    d: "m0 10c0-5.5 4.5-10 10-10h115c5.5 0 10 4.5 10 10v92c0 5.5-4.5 10-10 10h-115c-5.5 0-10-4.5-10-10z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_28021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m32 29h57v33h-57z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m33 30h55v31h-55z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m40 39h58v31h-58z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m41 40h56v29h-56z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13157",
    className: "s3",
    d: "m50 50h57v34h-57z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_93",
    className: "s0",
    d: "m70.8 66c-3.1 0-5.5-2.5-5.5-5.5 0-3 2.4-5.5 5.5-5.5 3 0 5.5 2.5 5.5 5.5 0 3-2.5 5.5-5.5 5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13149",
    className: "s0",
    d: "m82.3 55h11v11h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33802",
    className: "s0",
    d: "m70.6 69.1l5.4 10.7h-10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33801",
    className: "s0",
    d: "m82.3 69.1v10.7h10.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignCanvas);
export default __webpack_public_path__ + "static/media/design_canvas.659456afae672fb4912c37619b4faeaa.svg";
export { ForwardRef as ReactComponent };